<template>
    <div class="layer">
        <div class="wrap">
            <Header></Header>
            <div class="content_layer">
                <div class="content">
                    <!-- <Menu></Menu> -->
                    <div class="search_form">
                        <div class="sns">
                            <ul>
                                <li v-for="(item, idx) in sns.list">
                                    <img
                                        :src="!sns.selected.some((idx) => item.idx === idx) ? item.disableImg : item.activeImg"
                                        alt=""
                                        @click="selectSns(item.idx)"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div class="search_input">
                            <div class="search_keyword">
                                <p class="search_type">Keyword</p>
                                <input
                                    type="text"
                                    v-model="search.keyword"
                                    name="searchKeyword"
                                    class="searchKeyword"
                                    placeholder="키워드를 입력하세요"
                                    @keydown.enter="searchApi"
                                />
                            </div>
                            <div class="search_img">
                                <p class="search_type">Image</p>
                                <div class="file_wrap">
                                    <div
                                        class="fileupload"
                                        :class="search.file ? 'upload' : ''"
                                        @drop.prevent="handleDrop"
                                        @click="triggerFileInput"
                                    >
                                        <div :class="search.file ? 'upload_img' : ''">
                                            <img :src="selectFile.url" alt="" />
                                        </div>
                                        <span v-html="search.file ? search.file.name : '이미지를 첨부해주세요'"></span>
                                    </div>
                                    <input type="file" id="fileInput" @change="FileUpload" hidden accept="image/*" />
                                </div>
                            </div>
                        </div>
                        <div class="search_btn">
                            <button @click="searchApi">검색</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal_bg" v-if="state.isLoading">
        <Spinner></Spinner>
    </div>
</template>
<script lang="ts" config>
    import { globalStore, reactive, Header, onMounted, Menu, imgRender, apiService, router, returnCode, Spinner } from "@/BaseComponent";

    export default {
        props: {},
        components: {
            Header,
            Menu,
            Spinner,
        },
        setup() {
            const { changeCode } = returnCode();
            const global = globalStore();
            const state = reactive({
                isLoading: false as boolean,
            });
            const sns = reactive({
                list: [
                    {
                        idx: 1,
                        key: "isTwitter",
                        activeImg: require("@/assets/sns/Twitter.png"),
                        disableImg: require("@/assets/sns/Twitter_gy.png"),
                    },
                    {
                        idx: 6,
                        key: "isBlueSky",
                        activeImg: require("@/assets/sns/Bluesky.png"),
                        disableImg: require("@/assets/sns/Bluesky_gy.png"),
                    },
                    {
                        idx: 2,
                        key: "isGoogle",
                        activeImg: require("@/assets/sns/Google.png"),
                        disableImg: require("@/assets/sns/Google_gy.png"),
                    },
                    {
                        idx: 3,
                        key: "isNaver",
                        activeImg: require("@/assets/sns/Naver.png"),
                        disableImg: require("@/assets/sns/Naver_gy.png"),
                    },
                    {
                        idx: 4,
                        key: "isYoutube",
                        activeImg: require("@/assets/sns/Youtube.png"),
                        disableImg: require("@/assets/sns/Youtube_gy.png"),
                    },
                    {
                        idx: 5,
                        key: "isInstagram",
                        activeImg: require("@/assets/sns/Instagram.png"),
                        disableImg: require("@/assets/sns/Instagram_gy.png"),
                    },
                ],
                selected: [] as Array<number>,
            });
            const search = reactive({
                keyword: "" as string,
                file: null as any,
            });
            const selectFile = reactive({
                url: require("@/assets/common/image_upload.png") as string,
                name: "" as string,
            });

            onMounted(() => {
                global.setSelectMenu(0);
                getNationList();
                getDeptList();
                getPositionList();
                getTypeList();
                getDetailTypeList();
            });

            const getNationList = async () => {
                const res = await apiService.base.getNationList();
                if (res.returnCode === 0) {
                    global.setNationList(res.list);
                }
            };
            const getDeptList = async () => {
                const res = await apiService.base.getDeptList();
                if (res.returnCode === 0) {
                    global.setDept(res.list);
                }
            };
            const getPositionList = async () => {
                const res = await apiService.base.getPositionList();
                if (res.returnCode === 0) {
                    global.setPosition(res.list);
                }
            };
            const getTypeList = async () => {
                const res = await apiService.base.getTypeList();
                if (res.returnCode === 0) {
                    global.setType(res.list);
                } else {
                    changeCode(res.returnCode);
                }
            };
            const getDetailTypeList = async () => {
                const res = await apiService.base.getDetailTypeList();
                if (res.returnCode === 0) {
                    global.setDetailType(res.list);
                } else {
                    changeCode(res.returnCode);
                }
            };

            const handleDrop = (event: DragEvent) => {
                FileUpload(event);
            };
            const triggerFileInput = () => {
                if (search.file) {
                    if (confirm("삭제하시겠습니까?")) {
                        deleteFile();
                        resetFileInput();
                    }
                } else {
                    const fileInput = document.getElementById("fileInput") as HTMLInputElement;
                    fileInput.click();
                }
            };

            const FileUpload = (e: any) => {
                if (e) {
                    search.file = e.target.files;
                    if (search.file.length > 0) {
                        const file = search.file[0];
                        let url = URL.createObjectURL(file);
                        selectFile.url = url;
                        imgRender(search.file, selectFile.url);
                        search.file = file;
                    }
                }
            };
            const resetFileInput = () => {
                const fileInput = document.getElementById("fileInput") as HTMLInputElement;
                fileInput.value = "";
            };
            const deleteFile = () => {
                selectFile.url = require("@/assets/common/image_upload.png");
                search.file = null;
            };

            const selectSns = (idx: number) => {
                if (sns.selected.includes(idx)) {
                    sns.selected = sns.selected.filter((item) => item !== idx);
                } else {
                    sns.selected.push(idx);
                }
            };

            const searchApi = async () => {
                const param: FormData = new FormData();
                if (search.keyword !== "" || search.file !== null) {
                    if (search.keyword !== "") {
                        if (![1, 3, 4, 5, 6].some((item) => sns.selected.includes(item))) {
                            return alert("X, 블루스카이, 네이버, 유튜브, 인스타는 키워드가 필수 입니다.");
                        }
                    }
                    if (search.file) {
                        if (!sns.selected.includes(2)) {
                            return alert("이미지 검색을 위해서는 구글이 선택 되어있어야합니다.");
                        }
                    }
                    if (search.file && !search.keyword) {
                        if (!sns.selected.includes(2)) {
                            return alert("이미지만 검색을 위해서는 구글이 선택 되어있어야합니다.");
                        }
                    }
                } else return alert("키워드 또는 이미지의 값은 필수 입니다.");
                if (confirm("검색을 진행하시겠습니까?")) {
                    state.isLoading = true;
                    sns.list.map((item) => param.append(item.key, sns.selected.includes(item.idx) ? "1" : "0"));
                    param.append("keyword", search.keyword);
                    param.append("file", search.file);
                    const res = await apiService.search.search(param);
                    if (res.returnCode === 0) {
                        // alert("검색을 진행 완료되었습니다. \n결과는 순차적으로 추가됩니다.");
                        router.push("/search/history");
                    } else {
                        alert(changeCode(res.returnCode));
                    }
                    state.isLoading = false;
                }
            };
            return {
                sns,
                state,
                search,
                triggerFileInput,
                handleDrop,
                FileUpload,
                selectFile,
                deleteFile,
                selectSns,
                searchApi,
            };
        },
    };
</script>
<style scoped>
    .content {
        padding: 20px 0;
    }
</style>
